import styled from 'styled-components';
import { ToastStyleType } from './types';

export const ToastContainer = styled.div<{
  type: ToastStyleType;
  index: number;
}>`
  width: 100%;
  height: ${({ theme }) => theme.toast.height}px;
  position: relative;
  background-color: ${({ theme, type }) => theme.toast.types[type].backgroundColor};
  box-shadow: 0px 5px 13px rgba(0, 0, 0, 0.29);
  border-radius: 10px;
  z-index: ${({ theme }) => theme.layers.topLayer};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
`;

export const ToastWrapper = styled.div<{ isMobile: boolean }>`
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-size: ${({ isMobile }) => (!isMobile ? '16px' : '14px')};
  gap: 10px;
  margin-bottom: 16px;
  padding-left: ${({ isMobile }) => (!isMobile ? '10%' : '16px')};
  padding-right: ${({ isMobile }) => (!isMobile ? '10%' : '16px')};
  position: fixed;
  width: 100%;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 18px;
`;

export const BodyContainer = styled.p`
  margin-left: 8px;
`;
